"use strict";

import {
  getElementData,
  generateMetadata,
  linkObjects,
  groupNotes,
  rankInfo,
  extractResults,
  extractComparisons,
  extractResponses,
  expandComparisonFamilies,
  generateThemeSlugs,
  PRODUCT_KEYS as S,
} from "./data_helpers.js";
import { reduceToObject, twoWayKeyMapping } from "./shared.js";

let data;
if (typeof document !== "undefined") {
  data = getElementData("#app_data", "data");
  window.dbgData = data;
} else {
  // HT: https://stackoverflow.com/a/38056891/179583
  // and https://stackoverflow.com/q/22233950/179583
  let nodeRequire = require, // ~HACK: bypass browserify
    fs = nodeRequire("fs");
  let dataJSON = fs.readFileSync("/dev/stdin");
  data = JSON.parse(dataJSON);
}

Object.assign(data, rankInfo(data.survey_ranks, data.other_config.ranges));

let survey_list = data.survey.list;
survey_list.forEach((year, idx) => {
  year._item_index = idx;
});
let full_list = survey_list.filter((d) => d.has_measures); // most *recent* year at index 0
full_list.forEach((year, idx) => {
  year._score_index = idx;
});
data.survey._fullYears = full_list.slice(0).reverse();
data.survey._mainYear = full_list[0];

data.levelLabels = data.other_config.level_labels;
data.subjectLabels = twoWayKeyMapping(data.other_config.subjects);
data.noteContexts = twoWayKeyMapping(data.other_config.note_contexts);

data.comparisonFamilies = expandComparisonFamilies(data.comparisons);

data.essentials = reduceToObject(data.essentials, (d) => {
  return [
    d.slug,
    {
      ...generateMetadata("essentials", d),
      _results: extractResults(data, "all", d),
      _comparisons: extractComparisons(data, "essentials", d),
      ...d,
    },
  ];
});
// ~HACK: make sure to apply the *actual* overall label needed for Nav's .organized-text
data.essentials.overall._results.latest.rank.overall_long_label =
  data.overall_long_label;

data.measures = reduceToObject(data.measures, (d) => {
  return [
    d.slug,
    {
      ...generateMetadata("measures", d),
      _results: extractResults(data, "all", d),
      _comparisons: extractComparisons(data, "measures", d),
      _resources: [],
      ...d,
    },
  ];
});

data.items = reduceToObject(data.items || [], (d) => {
  return [
    d.slug,
    {
      ...generateMetadata("items", d),
      _responses: extractResponses(data, d),
      ...d,
    },
  ];
});

linkObjects(data, data.essentials, data.measures, data.items);

if (data.survey.product_key === S.ECE) {
  data.survey.themeSlugs = generateThemeSlugs(
    data.essentials.overall._children,
  );
}

data._processAsyncItems = (measure, items, resources) => {
  items.forEach((d) => {
    let item = {
      ...generateMetadata("items", d),
      _responses: extractResponses(data, d),
      ...d,
    };
    item._parent = measure;
    measure._children.push(item);
    data.items[item.slug] = item;
  });
  resources.forEach((d) => {
    measure._resources.push(d);
  });
};

if (!data.school_data) data.school_data = [];
data.schools = data.school_data.map(({ name, slug, url, data: sdata }) => {
  let essentials = reduceToObject(sdata.essentials, (d) => [
      d.slug,
      {
        ...generateMetadata("essentials", d),
        _results: extractResults(data, "all", d),
        ...d,
      },
    ]),
    measures = reduceToObject(sdata.measures, (d) => [
      d.slug,
      {
        ...generateMetadata("measures", d),
        _results: extractResults(data, "all", d),
        ...d,
      },
    ]);
  linkObjects(data, essentials, measures);
  return { name, slug, url, essentials, measures };
});

if (data.notes)
  data.notes.forEach((d) => (d.when_modified = new Date(d.when_modified)));
data.notesByContextByMeasure = groupNotes(data.notes || []);

let _mslugs = Object.keys(data.measures);
let _analyses = reduceToObject(data.analyses || [], (d) => [d.measure, d]);
data.analysesByMeasure = reduceToObject(_mslugs, (s) => [
  s,
  _analyses[s] || { _placeholder: true, needs_growth: null, rationale: "" },
]);

export default data;
